const DescribeItems = [
    
    { "label": "冷的", "icon": require('../icons/Describe/冷的.png'), "isFolder": false },
    { "label": "热的", "icon": require('../icons/Describe/热的.png'), "isFolder": false },
    { "label": "吵", "icon": require('../icons/Describe/吵.png'), "isFolder": false },
    { "label": "安静", "icon": require('../icons/Describe/安静.png'), "isFolder": false },
    { "label": "困难", "icon": require('../icons/Describe/困难.png'), "isFolder": false },
    { "label": "大的", "icon": require('../icons/Describe/大.png'), "isFolder": false },
    { "label": "小的", "icon": require('../icons/Describe/小的.png'), "isFolder": false },
    { "label": "好笑", "icon": require('../icons/Describe/好笑.png'), "isFolder": false },
    { "label": "快", "icon": require('../icons/Describe/快.png'), "isFolder": false },
    { "label": "慢", "icon": require('../icons/Describe/慢.png'), "isFolder": false },
    { "label": "新的", "icon": require('../icons/Describe/新的.png'), "isFolder": false },
    { "label": "旧的", "icon": require('../icons/Describe/旧的.png'), "isFolder": false },
    { "label": "湿的", "icon": require('../icons/Describe/湿的.png'), "isFolder": false },
    { "label": "恶心", "icon": require('../icons/Describe/恶心.png'), "isFolder": false },
    { "label": "脏", "icon": require('../icons/Describe/脏.png'), "isFolder": false },
    { "label": "一样的", "icon": require('../icons/Describe/一样的.png'), "isFolder": false },
    { "label": "不同", "icon": require('../icons/Describe/不同.png'), "isFolder": false },
    { "label": "完成", "icon": require('../icons/Describe/完成.png'), "isFolder": false },
    { "label": "更多", "icon": require('../icons/Describe/更多.png'), "isFolder": false },
    { "label": "全部", "icon": require('../icons/Describe/全部.png'), "isFolder": false },
    { "label": "一些", "icon": require('../icons/Describe/一些.png'), "isFolder": false },

    { "label": "返回", "icon": require('../icons/HOME.png'), "isFolder": true }
];

export default DescribeItems;
